import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ReactComponent as Cancel } from '../assets/cancel.svg';

export default function InAppNotifications({ value, saveInAppNotifications, hideInAppNotifications }) {
	const inAppNotificationDefault = {
		notification_text: "",
		points_threshold: 0,
		button_text: "",
		button_url: "",
		send_sms: false,
		sms_content: ""
	};

	const [inAppNotifications, setInAppNotifications] = useState(
		value && value.length > 0 ? value : [inAppNotificationDefault]
	);

	const { register, handleSubmit, watch } = useForm();
	const [message, changeMessage] = useState('');

	const setMessage = (text) => {
		changeMessage(text);
		setTimeout(() => {
			changeMessage('');
		}, 3000);
	};

	const saveButton = (data) => {
		console.log(data);
		saveInAppNotifications(data['inAppNotifications']);
		hideInAppNotifications();
	};

	const addNewNotification = () => {
		setInAppNotifications([...inAppNotifications, inAppNotificationDefault]);
	};

	const removeNotification = (index) => {
		const updatedNotifications = inAppNotifications.filter((_, idx) => idx !== index);
		setInAppNotifications(updatedNotifications);
	};

	return (
		<div className="right right_logo texts">
			<div className="dashed-border">
				<div className="title">
					<div>
						<div className="name">In-App Notifications</div>
					</div>
					<div>
						<div className="cancel" onClick={hideInAppNotifications}>
							<Cancel />
						</div>
					</div>
				</div>

				<form onSubmit={handleSubmit(saveButton)}>
					{inAppNotifications.map((notification, index) => {
						const sendSMSField = `inAppNotifications[${index}].send_sms`;
						const smsChecked = watch(sendSMSField);

						return (
							<div key={index} className="notification-item">
								<button type="button" onClick={() => removeNotification(index)} className="button remove-btn">
									Remove
								</button>
								<div className="subtitle">Text of the notification</div>
								<textarea
									{...register(`inAppNotifications[${index}].notification_text`)}
									placeholder="Notification Text"
									defaultValue={notification.notification_text}
									className="textarea-style"
								/>
								<div className="subtitle">Points needed to show this notification</div>
								<input
									{...register(`inAppNotifications[${index}].points_threshold`)}
									placeholder="Points Threshold"
									type="number"
									defaultValue={notification.points_threshold}
									className="input-style"
								/>
								<div className="subtitle">Button text (optional)</div>
								<input
									{...register(`inAppNotifications[${index}].button_text`)}
									placeholder="Button Text"
									type="text"
									defaultValue={notification.button_text}
									className="input-style"
								/>
								<div className="subtitle">Button URL (optional)</div>
								<input
									{...register(`inAppNotifications[${index}].button_url`)}
									placeholder="Button URL"
									type="text"
									defaultValue={notification.button_url}
									className="input-style"
								/>

								<div className="subtitle">Send Text Message?</div>
								<input
									type="checkbox"
									{...register(sendSMSField)}
									defaultChecked={notification.send_sms}
								/>

								{smsChecked && (
									<div>
										<div className="subtitle">Text Message Body</div>
										<textarea
											{...register(`inAppNotifications[${index}].sms_content`)}
											placeholder="SMS Content"
											defaultValue={notification.sms_content}
											className="textarea-style"
										/>
									</div>
								)}
							</div>
						)
					}
					)}

					<button type="button" onClick={addNewNotification} className="button add">
						Add New Notification
					</button>

					<button type="submit" className="button check save">
						Save
					</button>

					<div className="error">{message}</div>
				</form>
			</div>
		</div>
	);
}
